export enum SceneName {
    // Démo du template (conservée pour référence).
    House = 'house',
    Test = 'test',

    // Campus LaCaze Life (ids = locationId CharacterFactory = homeLocation dans characters.json).
    Campus = 'campus',               // overworld (portail, parking, cour, terrains) — hub
    Administration = 'administration',
    VieScolaire = 'vie-scolaire',
    Cdi = 'cdi',
    Infirmerie = 'infirmerie',
    SalleProfs = 'salle-profs',
    Cantine = 'cantine',
    Gymnase = 'gymnase',
    Classroom = 'classroom',
    ClassroomB = 'classroom-b',      // salles supplémentaires (multi-classe : une salle par classe)
    ClassroomC = 'classroom-c',
    Holiday = 'holiday',             // carte "vacances" (coming soon) — où les élèves se rassemblent pendant les vraies vacances
    Room = 'room',                   // "Chez moi" — chambre d'un·e avatar (une seule scène réutilisée par room id)

    // Futur (hors périmètre actuel) : scènes de la ville.
    VilleGrisolles = 'ville-grisolles',
    BordsDeGaronne = 'bords-de-garonne',

    // Overlay UI (lancé en parallèle, ne dort jamais).
    Dialogue = 'dialogue',
    Controls = 'controls', // contrôles tactiles (joystick + bouton), lancé seulement sur mobile.
    Hud = 'hud', // jauges d'humeur du joueur (overlay permanent).
    Weather = 'weather', // météo réelle de Grisolles (widget en haut à droite, overlay permanent).
    Log = 'log', // Journal : panneau d'historique des actions/événements (overlay).
    Minimap = 'minimap', // plan du collège : tous les agents en points (overlay permanent).
    Chambres = 'chambres', // "Les Chambres" : annuaire des chambres (le « lien » sur la carte), overlay.
}